/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type PropertyKind = typeof PropertyKind[keyof typeof PropertyKind];


export const PropertyKind = {
  object: 'object',
  group: 'group',
} as const;
